import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GatewayType } from '@vi-iot/client';
import { Observable } from 'rxjs';

import { GatewayCommissioningActions } from './gateway-commissioning.actions';
import {
  GATEWAY_COMMISSIONING_DEVICE,
  GATEWAY_COMMISSIONING_FLOW,
  GATEWAY_COMMISSIONING_STEP,
  TransferInstallationFormData,
} from './gateway-commissioning.model';
import { GatewayCommissioningSelectors } from './gateway-commissioning.selectors';

@Injectable({ providedIn: 'root' })
export class GatewayCommissioningStore {
  activeStep$ = this.store.select(GatewayCommissioningSelectors.getActiveStep());
  selectedDevice$ = this.store.select(GatewayCommissioningSelectors.getSelectedDevice());
  commissioningFlow$ = this.store.select(GatewayCommissioningSelectors.getCommissioningFlow());
  formData$ = this.store.select(GatewayCommissioningSelectors.getFormData());
  state$ = this.store.select(GatewayCommissioningSelectors.getState());
  transferInstallationLoading$ = this.store.select(
    GatewayCommissioningSelectors.getTransferInstallationLoading()
  );
  isGatewayCommissioningAvailable$ = this.store.select(GatewayCommissioningSelectors.isAvailable());
  isGatewayVerificationOngoing$ = this.store.select(
    GatewayCommissioningSelectors.isGatewayVerificationOngoing()
  );
  isAnyFormControlFilledOut$ = this.store.select(
    GatewayCommissioningSelectors.isAnyFormControlFilledOut()
  );
  selectGatewayVerificationError$ = this.store.select(
    GatewayCommissioningSelectors.selectGatewayVerificationError()
  );
  isGatewayVerificationDataRegistered$ = this.store.select(
    GatewayCommissioningSelectors.isGatewayVerificationDataRegistered()
  );
  emailAddress$ = this.store.select(GatewayCommissioningSelectors.getEmailAddress());
  gatewaysTags$ = this.store.select(GatewayCommissioningSelectors.selectGatewayTags);

  constructor(private store: Store) {}

  setActiveStep(payload: { activeStep: GATEWAY_COMMISSIONING_STEP }): void {
    this.store.dispatch(GatewayCommissioningActions.setActiveStep(payload));
  }

  setFormData(formData?: TransferInstallationFormData): void {
    this.store.dispatch(GatewayCommissioningActions.setFormData({ formData }));
  }

  setSelectedDevice(selectedDevice: GATEWAY_COMMISSIONING_DEVICE): void {
    this.store.dispatch(GatewayCommissioningActions.setSelectedDevice({ selectedDevice }));
  }

  setCommissioningFlow(commissioningFlow: GATEWAY_COMMISSIONING_FLOW): void {
    this.store.dispatch(GatewayCommissioningActions.setCommissioningFlow({ commissioningFlow }));
  }

  transferInstallation(payload: { withoutOwner: boolean }): void {
    this.store.dispatch(GatewayCommissioningActions.registerGateway.attempt({ payload }));
  }

  commercialRegisterGateway(payload: { withoutInvitation: boolean }): void {
    this.store.dispatch(GatewayCommissioningActions.commercialRegisterGateway.attempt({ payload }));
  }

  sendInvitationToTransferOwnership(payload: {
    installationId: number;
    inviteeEmail: string;
  }): void {
    this.store.dispatch(GatewayCommissioningActions.sendInvitation.attempt(payload));
  }

  verifyGateway(gatewaySerial: string, gatewayPassword: string): void {
    this.store.dispatch(
      GatewayCommissioningActions.verifyGateway.attempt({ gatewaySerial, gatewayPassword })
    );
  }

  isGatewayOfType(gatewayType: GatewayType): Observable<boolean> {
    return this.store.select(GatewayCommissioningSelectors.isGatewayOfType(gatewayType));
  }

  clearState(): void {
    this.store.dispatch(GatewayCommissioningActions.clearState());
  }
}
